// src/TranscriptionContext.tsx
import React, { createContext, useContext, useEffect, useRef, useState, ReactNode } from 'react';
import { useContactContext } from '../providers/ContactProvider';
import { logger } from '../utilities/logger';
import 'amazon-connect-streams';
import { getConfig } from '../config';

type MessageObject = {origin:string; message: string};
// Define the context type
type TranscriptionContextType = {
    messages: MessageObject[];
};


// Create the context
const TranscriptionContext = createContext<TranscriptionContextType | undefined>(undefined);
const appConfig = getConfig();
const WS_HOST = appConfig.REALTIME_API_WS_HOST; //"cojs3h6ei4.execute-api.us-west-2.amazonaws.com";
const WS_STAGE = appConfig.REALTIME_API_WS_STAGE; //"dev";


function getWebsocketUrl(_authToken: string) {
    const header = encodeAppSyncCredentials(_authToken);
    const payload = window.btoa(JSON.stringify({}));
    const url = `wss://${WS_HOST}/${WS_STAGE}/?header=${header}&payload=${payload}`;
 
    return url;
}

function encodeAppSyncCredentials(_authToken: string) {
    const creds = {
      host: WS_HOST,
      Authorization:_authToken
    };
    const b64Creds = window.btoa(JSON.stringify(creds));
  
    return b64Creds;
}


// Define props for the provider
interface TranscriptionProviderProps {
    children: ReactNode;
}

// Create the provider component
export const TranscriptionProvider: React.FC<TranscriptionProviderProps> = ({ children }) => {

//    const [contactAttributes, setContactAttributes] =
    useState<connect.AttributeDictionary>({});
  
    const { selectedContact } = useContactContext();
    const [contactAttributes, setContactAttributes] =
    useState<connect.AttributeDictionary>({});

    const [messages, setMessages] = useState<MessageObject[]>([]);
    const socketRef = useRef<WebSocket | null>(null);

    const log = logger();

    useEffect(() => {
        // Create WebSocket connection
        //var cont_id = selectedContact.getContactId();
        try {

            if (selectedContact) {
                selectedContact.onRefresh((contact) =>
                    setContactAttributes(contact.getAttributes())
                  );                
                const attributes = selectedContact.getAttributes();
                const cont_id = selectedContact.getContactId();
                //alert(cont_id);

                if(!socketRef.current && attributes && attributes.token && attributes.token.value){
                    const authToken = cont_id+"+"+attributes.token.value;
                    socketRef.current = new WebSocket(getWebsocketUrl(authToken));

                    socketRef.current.addEventListener("open", () => {
                        console.log("websocket.current realtime transcription stream opened.");
                        const newMsg = {origin:"SYSTEM", message: "Transcription started for contact Id : "+cont_id};
                        setMessages((prevMessages) => [newMsg]);

                    });
            
                    socketRef.current.addEventListener("message", (event) => {
                        const message = JSON.parse(event.data);
                        console.log(message);
                        if(message && message.data && message.data.Segments && message.data.Segments[0].Transcript && message.data.Segments[0].Transcript.Content){
                            const newMsg = {origin:message.data.Segments[0].Transcript.ParticipantRole, message: message.data.Segments[0].Transcript.Content};
                            setMessages((prevMessages) => [...prevMessages, newMsg]);
                            //setMessages((prevMessages) => [...prevMessages, +" : "+]);  
                        }

                    });            

                    socketRef.current.onclose = () => {
                        console.log("websocket.current realtime transcription stream closed.");
                        const newMsg = {origin:"SYSTEM", message: "No Active or Selected Contact."};
                        setMessages((prevMessages) => [...prevMessages, newMsg]);

                       // setMessages((prevMessages) => [...prevMessages, "No Active or Selected Contact."]);

                    }
                }
            }else{
                if(socketRef.current){    
                    socketRef.current.close();
                    socketRef.current = null;
                    const newMsg = {origin:"", message: ""};
                    setMessages((prevMessages) => [newMsg]);

                    //setMessages((prevMessages) => [""]);

                }

            }

        } catch (error) {
            log.error(error);
        }

    }, [selectedContact, contactAttributes]);

    return (
        <TranscriptionContext.Provider value={{ messages }}>
            {children}
        </TranscriptionContext.Provider>
    );
};

// Custom hook to use the Transcription context
export const useTranscription = (): TranscriptionContextType => {
    const context = useContext(TranscriptionContext);
    if (!context) {
        throw new Error('useTranscription must be used within a TranscriptionProvider');
    }
    return context;
};